<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Document Template Add</li>
        </ol>
    </div>
  </section>
  <section>
      <div class="container-fluid">
          <div class="row mb-2">
              <div class="col-sm-12 p-0">
                  <div class="card Title-bar-blue">
                      <div class="devcare-card-header">
                          <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i>Document Template Add</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <form [formGroup]="documentTemplateAddForm">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-6">
                    <label for="templateName">Template Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="templateName" type="text" pInputText>
                  </div>
                  <div class="p-field p-col-12 p-md-6">
                    <label for="screenName">Screen Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="screenName" type="text" pInputText>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <!-- <div class="p-field p-col-12 p-md-6">
                    <label for="subject">Subject<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="200" formControlName="subject" type="text" pInputText>
                  </div> -->
                  <div class="p-field p-col-12 p-md-6">
                    <label for="isActive">Is Active</label>
                    <br />
                    <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-12">
                    <label for="description">Description<span class="required-field">*</span></label>
                    <textarea formControlName="description" maxlength="100000" pInputTextarea class="form-control"
                    [rows]="6"></textarea>
                    <!-- <p-editor formControlName="description" [style]="{'height':'320px'}"></p-editor> -->
                    <!--<span class="text-danger"
                      *ngIf="this.emailTemplateAddForm.controls?.description?.hasError('maxlengthError')">
                      Only 5000 characters allowed.
                    </span>-->
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
          class="p-button-sm p-button-raised p-button-danger m-2 float-right" (click)="cancel()"></button>
          <button pButton pRipple type="button" label="Save" icon="pi pi-check" [disabled]="!this.documentTemplateAddForm.valid"
           class="p-button-sm p-button-raised p-button-success m-2 float-right" (click)="save(documentTemplateAddForm)"></button>
        </div>
      </div>
    </section>
     